import React from 'react';
import Fade from 'react-reveal/Fade';
import Link from 'gatsby-link';
const HomeWorkProject = (props) => {
    const background = "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(" + props.src + ")";
    return (

        <Link to={props.to}>
            <Fade bottom delay={props.delay}>
                <div className="project">
                    <div className="hovereffect">
                        <img className="img-responsive" src={props.src} alt="" />
                        <div className="overlay">
                            <h4>{props.title}</h4>
                            <p>
                                <span >View Project</span>
                            </p>
                        </div>
                    </div>
                </div>
            </Fade>
        </Link>
    )
};

export default HomeWorkProject;


// WEBPACK FOOTER //
// ./src/components/home/Work/project.js